import React, { Component } from 'react';
import { HttpRequest, CheckSupportIDException } from '../../common/CommonOperations';
import { MessageBox } from '../../common/modalBox/MessageBox';
import './AIOfficeNewsLetter.css';

export class AIOfficeNewsLetter extends Component {
    static displayName = AIOfficeNewsLetter.name;
    constructor(props) {
        super(props);
        this.state = {
            otherSelect: false, showMessageBox: false, message: '', messageType: '1', director: '',
            isSubscribed: null,
            loading: true,
            isPopupOpen: false,
            popupText: ""
        };
        this.UserDetails = this.props.UserDetails;
    }

    async componentDidMount() {
        document.title = 'AI Office Newsletter';

        await this.checkIsMailSubscribed();

        console.log('AI Office Newsletter');
    }

    async checkIsMailSubscribed() {
        if (this.UserDetails.NTLogin == null) return;

        var response = await HttpRequest('AIOffice/CheckIsMailSubscribed', 'get', '');
        const data = await CheckSupportIDException(response)
        console.log(data);
        if (data == null || (data && !data.isSuccessful)) {
            this.setState({ showMessageBox: true, messageType: "3", message: data.friendlyMessage });
        } else {
            this.setState({ isSubscribed: data.isSubscribed });
        }
    }

    handleSubscribe = async () => {
        var response = await HttpRequest('AIOffice/InsertUpdateMailSubscription', 'post', '');
        const data = await CheckSupportIDException(response)
        console.log(data);
        if (data == null || (data && !data.isSuccessful)) {
            this.setState({ showMessageBox: true, messageType: "3", message: data.friendlyMessage });
        } else {
            var text = this.state.isSubscribed ? 'Unsubscribed' : 'Subscribed';
            text = 'You have successfully ' + text + '!';
            this.setState({ isSubscribed: !this.state.isSubscribed, showMessageBox: true, message: text }, () => {
                setTimeout(() => { this.HideMessageBox() }, 5000);
            });
        }
    }

    ShowMessageBox = (message, messageType) => this.setState({ showMessageBox: true, messageType: messageType, message: message });
    HideMessageBox = () => this.setState({ showMessageBox: false });

    render() {
        return (
            <>
                <div class="container-newsletter">
                    {/*<div className="background-layer"><img src="./images/aioffice/ai-assistant-bg.png" alt="" /></div>*/}
                    <div class="main-container">

                        <div class="image-placeholder">
                            <img src="./images/AIOffice/header-logo.svg" alt="AI Office Logo"></img>
                        </div>

                        <div class="content">
                            {
                                ((this.state && this.state.isSubscribed != null && !this.state.isSubscribed) &&
                                    <>
                                        <p>
                                            <b>Thank you for your interest in the AI Office newsletter—Knowledge Bytes! </b>
                                            By subscribing, you’ll receive future updates from the AI Office. Don't miss the insights that redefine your workday. We promise to keep our updates byte-sized, with opportunities to drill down further.
                                        </p>

                                        <p class="instruction">Now, just hit one more button:</p>
                                    </>
                                )
                            }
                            {

                                ((this.state && this.state.isSubscribed != null && this.state.isSubscribed) &&
                                    <p class="instruction"><b>Thank you! You’ve already subscribed to the AI Office.</b></p>
                                )
                            }

                            <button className="button" type="button" aria-label="Subscribe to mailing list" onClick={this.handleSubscribe}>
                                <span className="label-frame"><span className="label-3">{this.state.isSubscribed ? 'Unsubscribe' : 'Subscribe'}</span></span>
                            </button>

                            <p class="footer-text">
                                See you in your inbox! Have a question? Contact us by emailing the
                                <a href="mailto:AIOffice@dish.com"> AIOffice@dish.com</a>.
                            </p>
                        </div>
                    </div>
                </div>
                <footer>
                    <p>&copy; 2025 EchoStar Corporation</p>
                </footer>
                <MessageBox show={this.state.showMessageBox} onHide={this.HideMessageBox} type={this.state.messageType} message={this.state.message} />
            </>
        )
    }
}